<input type="checkbox"
       [id]="field.id"
       [name]="field.id"
       class="k-checkbox"
       [(ngModel)]="checked"
       (change)="valueChange()"
       [disabled]="disabled || readOnly"
       [ngClass]="{'read-only': readOnly}"
/>
<label class="k-checkbox-label"
       [for]="field.id"
>
    <p class="consent-title" *ngIf="field.name">{{field.name}}</p>
    <span *ngIf="field.description" innerHTML="{{field.description}}" class="dynamic-consent"></span>
</label>
